<template>
  <div class="container" ref="container">
    <!-- <side-bar /> -->
    <router-view v-slot="{ Component }">
      <keep-alive :include="[store.getters.cacheKeepAlive]">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from "vue";
import SideBar from "@/components/SideBar.vue";
import store from "@/store";

const container = ref<null | HTMLElement>(null);
const initWindow = () => {
  if (container.value) {
    let scale;
    if (window.innerWidth === 1088) {
      scale = window.innerWidth / 1920;
      container.value.setAttribute(
        "style",
        `transform: scale(${scale});margin-top: ${
          (window.innerHeight - 1080 * scale) / 2
        }px;margin-left:0;`
      );
      return;
    }
    scale = window.innerHeight / 1080;
    container.value.setAttribute(
      "style",
      `transform: scale(${scale});margin-left: ${
        (window.innerWidth - 1920 * scale) / 2
      }px;margin-top:0;`
    );
  }
};

onMounted(() => {
  initWindow();
  window.addEventListener("resize", initWindow);
});

onUnmounted(() => {
  window.removeEventListener("resize", initWindow);
});
</script>

<style lang="less">
.content {
  padding: 28px 0 0 30px;
  .content-number {
    background: url(./assets/images/border.png) no-repeat;
    width: 1207px;
    height: 266px;
    margin-bottom: 18px;
    overflow: hidden;
    .com-h3 {
      margin-bottom: 0;
    }
  }
  .content-number-fl {
    width: 49%;
    display: flex;
    align-items: center;
    padding-left: 42px;
    box-sizing: border-box;
    li {
      width: 42px;
      height: 64px;
      background: #152346;
      border-radius: 1px;
      border: 1px solid #56b0db;
      margin-left: 13px;
      display: block;
      text-align: center;
      line-height: 64px;
      font-size: 60px;
    }
  }
  .content-number-fr {
    > div {
      position: relative;
      width: 175px;
      height: 175px;
      background: url(./assets/images/bg2.png) no-repeat;
      font-size: 20px;
      line-height: 120px;
      text-align: center;
      color: #fff;
      box-sizing: border-box;
    }
    .content-number-fr-total {
      width: 86%;
      height: 86%;
      position: absolute;
      top: 7%;
      left: 7%;
    }
    .content-number-fr-text {
      // padding-left: 30px;
      padding-left: 30px;
      font-size: 20px;
      color: #ffffff;
      line-height: 26px;
      margin-top: 6px;
      li {
        margin: 30px 0;
        p {
          width: 110px;
          font-size: 20px;
          font-weight: bold;
          white-space: nowrap;
        }
        .com-font {
          font-size: 48px;
          line-height: 40px;
          display: inline-block;
          padding-right: 10px;
        }
      }
    }
  }
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background-color: #539be0;
}

::-webkit-scrollbar-track {
  // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  background-color: transparent;
}
html,
body,
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.container {
  width: 1920px;
  height: 1080px;
  background: #061d5c url(./assets/images/bg.png) no-repeat center center;
  box-sizing: border-box;
  overflow: hidden;
  transform-origin: left top;
  user-select: none;
}
.box {
  display: flex;
}
.box-align-center {
  display: flex;
  align-items: center;
}
.box-between-center {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box-between {
  display: flex;
  justify-content: space-between;
}
.box-all-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-legend {
  font-size: 18px;
  color: #fff;
  line-height: 25px;
  // margin: 0 60px 0 40px;
  li {
    &::before {
      content: "";
      display: inline-block;
      width: 8px;
      height: 8px;
      vertical-align: middle;
      margin-right: 10px;
      border-radius: 50%;
      background-color: #4ebd9b;
    }
    &:first-child {
      &::before {
        background-color: #5b8ff9;
      }
    }
  }
}
.check-label {
  font-size: 14px;
  color: #5b84c4;
  line-height: 19px;
  margin: 11px 20px 0 0;
}
.check-box {
  width: 14px;
  height: 14px;
  background: #0c0e58;
  border: 1px solid #979797;
  border-radius: 50%;
  margin: 11px 9px 0 0;
  cursor: pointer;
  &.actived {
    background: #0b0d4a;
    border: 1px solid #01a2ee;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      width: 10px;
      height: 10px;
      background: #3bc0ff;
      top: 2px;
      left: 2px;
      border-radius: 50%;
    }
  }
}
.select-box {
  width: 491px;
  height: 36px;
  border-radius: 2px 2px 2px 0px;
  border: 1px solid #01acf8;
  position: relative;
  padding: 0 30px 0 14px;
  box-sizing: border-box;
  .el-dropdown {
    width: 100%;
  }
  .select-box-del {
    position: absolute;
    width: 16px;
    height: 16px;
    background: #061d5c url(./assets/images/del.png) no-repeat;
    background-size: cover;
    right: 12px;
    top: 11px;
    z-index: 1;
    cursor: pointer;
  }
  .el-select {
    position: absolute;
    top: 2px;
    opacity: 0;
    width: 95%;
  }
  .select-box-text {
    font-size: 14px;
    color: #5b84c4;
    line-height: 36px;
    width: 100%;
    outline: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  select {
    opacity: 0;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  &::after {
    content: "";
    position: absolute;
    right: 12px;
    top: 15px;
    width: 0;
    height: 0;
    border-width: 6px;
    border-style: solid;
    border-color: #01a2ee transparent transparent;
  }
}
.com-header {
  width: 550px;
  height: 28px;
  background: url("@/assets/images/line1.png");
  margin: 20px 0 0 29px;
  .com-h3 {
    margin: 0;
    transform: translate(8px, -8px);
  }
}
.com-header2 {
  width: 448px;
  height: 28px;
  background: url("@/assets/images/line3.png");
  .com-h3 {
    margin: 0;
    transform: translate(8px, -8px);
  }
}
.area3-select {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}
.rank-table {
  width: 100%;
  height: 500px;
  box-sizing: border-box;
  padding: 12px 0;
  margin-bottom: 10px;
  .tr {
    display: flex;
    align-items: center;
    margin: 16px 0;
    .td {
      font-size: 16px;
      position: relative;
      &:first-child {
        color: #fff;
        width: 30px;
        text-align: center;
      }
      &:nth-child(2) {
        color: #00dcfa;
        flex: 1;
        padding-left: 8px;
      }
      &:nth-child(3) {
        width: 441px;
      }
    }
    .fraction {
      color: #fff;
      position: absolute;
      right: 0;
      top: -20px;
      font-size: 16px;
    }
  }
}
.com-font {
  background: linear-gradient(180deg, #9cedfb 10%, #79bbfe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.content-number-bot {
  font-size: 24px;
  color: #fff;
  margin-top: 10px;
  img {
    display: inline-block;
    margin: 0 10px 0 14px;
  }
  .com-font {
    font-size: 32px;
    margin-right: 6px;
  }
}
.custom-select {
  font-size: 14px;
  color: #3c94e2;
  line-height: 19px;
  margin-right: 20px;
  position: relative;
  cursor: pointer;
  &::before {
    content: "";
    display: inline-block;
    width: 15px;
    height: 15px;
    background: #0c0e58;
    border: 1px solid #979797;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 5px;
    box-sizing: border-box;
  }
  &::after {
    content: "";
    position: absolute;
    width: 11px;
    height: 11px;
    background: #3bc0ff;
    border-radius: 50%;
    left: 2px;
    top: 5px;
    display: none;
  }
  &.actived {
    color: #fff;
    &::after {
      display: block;
    }
  }
}
.com-h3 {
  font-size: 20px;
  font-weight: bold;
  color: #4bc2ff;
  line-height: 26px;
  margin: 24px;
  &::after {
    content: "";
    width: 28px;
    height: 16px;
    margin-left: 12px;
    background: url(./assets/images/jiantou.png) no-repeat;
    display: inline-block;
    vertical-align: middle;
  }
}
.com-nav {
  background: #0b2364;
  border-radius: 1px;
  border: 1px solid #8fb1d3;
  display: flex;
  > div {
    font-size: 14px;
    font-weight: 600;
    color: #3c94e2;
    width: 70px;
    text-align: center;
    line-height: 32px;
    white-space: nowrap;
    cursor: pointer;
    &.active {
      color: #fff;
      background: #2145a4;
    }
  }
}
.td-text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-popover {
  font-size: 12px !important;
}
.el-popper.is-light .el-popper__arrow::before,
.el-popper.is-light,
.el-dropdown-menu,
.el-dropdown-menu__item,
.el-select-dropdown__item {
  color: #fff !important;
  background-color: #0c1061 !important;
}
.com-table {
  width: 628px;
  text-align: center;
  border-spacing: 0px;
  border-collapse: collapse;
  ::-webkit-scrollbar {
    width: 7px;
    background-color: transparent;
  }
  tr {
    box-sizing: border-box;
    table-layout: fixed;
    display: table;
    width: 100%;
  }
  &.home-table {
    th:first-child,
    td:first-child {
      width: 32px;
    }
  }

  /* 滚动条颜色 */
  ::-webkit-scrollbar-thumb {
    background-color: #539be0;
  }
  thead {
    th {
      height: 42px;
      font-size: 12px;
      font-weight: 600;
      color: #9cf1f9;
      text-align: center;
      white-space: nowrap;
    }
    background: linear-gradient(
      270deg,
      rgba(29, 38, 57, 0) 0%,
      #133da3 52%,
      rgba(24, 32, 53, 0) 100%
    );
    .com-table-head-sort {
      display: inline-block;
      vertical-align: middle;
      a {
        width: 0;
        height: 0;
        border-style: solid;
        cursor: pointer;
        &:first-child {
          content: "";
          display: block;
          margin-bottom: 4px;
          border-width: 6px 5px;
          border-color: transparent transparent #337192 transparent;
        }
        &:last-child {
          content: "";
          display: block;
          border-width: 6px 5px;
          border-color: #337192 transparent transparent transparent;
        }
        &.active {
          &:first-child {
            border-color: transparent transparent #fff transparent;
          }
          &:last-child {
            border-color: #fff transparent transparent transparent;
          }
        }
      }
    }
  }
  tbody {
    display: block;
    width: calc(100% + 7px); /*这里的8px是滚动条的宽度*/
    height: 400px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    tr {
      &:nth-child(even) {
        background: linear-gradient(
          89deg,
          rgba(32, 41, 58, 0) 0%,
          #122f7e 22%,
          #122f7e 81%,
          rgba(32, 41, 58, 0) 100%
        );
      }
      &:not(.no-hover) {
        &.active,
        &:hover {
          background: linear-gradient(
            270deg,
            rgba(99, 143, 255, 0) 0%,
            rgba(61, 195, 255, 0.65) 50%,
            rgba(99, 143, 255, 0) 100%
          ) !important;
          border: 1px solid #5accff;
          td {
            color: #fff;
          }
        }
      }
      td {
        height: 40px;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);

        .text-ellipsis {
          color: #4bc2ff;
          // width: 83px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .com-table-sort {
          font-size: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          // padding-left: 20px;
          span {
            font-size: 18px;
            color: #93dbff;
            margin-right: 3px;
          }
          img {
            display: block;
            margin: 0;
          }
        }
      }
    }
  }
}
.ct2 {
  margin: 0 auto;
  thead {
    background: rgb(16, 42, 129);
    height: 42px;
  }
  tbody {
    tr {
      height: 34px;
      &:nth-child(odd) {
        background: #0b2364;
      }
      &:nth-child(event) {
        background: linear-gradient(
          89deg,
          rgba(32, 41, 58, 0) 0%,
          #122f7e 22%,
          #122f7e 81%,
          rgba(32, 41, 58, 0) 100%
        );
      }
      td {
        color: #fff;
      }
    }
  }
}
// .com-table thead tr {
//   display: block;
// }
// .com-table tbody {
//   display: block;
//   overflow-y: auto;
//   overflow-x: hidden;
//   padding-right: 10px;
//   height: 370px;
// }
// .com-table th {
//   width: 20%;
// }
// .com-table td {
//   width: 20%;
// }
.h1-text {
  font-size: 34px;
  font-weight: bold;
  line-height: 64px;
  width: 100%;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  text-align: center;
  letter-spacing: 3px;
  font-style: italic;
  font-weight: bolder;
  background: linear-gradient(180deg, #9feaff 0%, #66a5fe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  &.style2 {
    font-size: 25px;
    line-height: 1.3;
  }
}
.area-box {
  box-shadow: inset 0px 0px 50px 0px rgba(2, 172, 245, 0.4);
  border: 1px solid transparent;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    width: 14px;
    height: 14px;
    background: url(./assets/images/top-left.png) no-repeat;
    top: -2px;
    left: -2px;
  }
  &::before {
    content: "";
    position: absolute;
    width: 14px;
    height: 14px;
    background: url(./assets/images/top-right.png) no-repeat;
    top: -2px;
    right: -2px;
  }
  > div {
    &::after {
      content: "";
      position: absolute;
      width: 14px;
      height: 14px;
      background: url(./assets/images/bottom-left.png) no-repeat;
      bottom: -2px;
      left: -2px;
    }
    &::before {
      content: "";
      position: absolute;
      width: 14px;
      height: 14px;
      background: url(./assets/images/bottom-right.png) no-repeat;
      bottom: -2px;
      right: -2px;
    }
    .area-box-fl {
      // float: left;
      width: 525px;
      margin: 0 16px 0 21px;
      img {
        display: block;
        margin: 15px auto;
      }
      .area-box-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .area-box-fr {
      // float: left;
      flex: 1;
      height: 616px;
      background: url(./assets/images/mapbg.png) no-repeat;
      margin: 20px 20px 0 0;
      position: relative;
      background-size: 100% 616px;
      h3 {
        font-size: 18px;
        font-weight: 600;
        color: #9cf1f9;
        position: absolute;
        top: 12px;
        left: 88px;
      }
      .charOne {
        position: absolute;
        // width: 622px;
        // height: 622px;
        // z-index: 9;
        width: 230px;
        height: 230px;
        z-index: 0;
        bottom: -10px;
        left: 29px;
      }
    }
    .ranking-box {
      display: flex;
      justify-content: space-around;
      margin-top: -20px;
      padding: 0 5%;
      .ranking-item {
        width: 115px;
        height: 126px;
        background: url(./assets/images/Ranking.png) no-repeat;
        position: relative;
        background-size: cover;
        &:first-child {
          transform: scale(0.7741);
          margin-top: 12px;
        }
        &:last-child {
          transform: scale(0.7741);
          margin-top: 12px;
        }
        span {
          font-size: 60px;
          font-weight: 600;
          color: #9cf1f9;
          opacity: 0.22;
          text-align: center;
          position: absolute;
          left: 0;
          right: 0;
          top: 12px;
          z-index: 0;
        }
        p {
          font-size: 18px;
          font-weight: 600;
          color: #9cf1f9;
          text-align: center;
          position: absolute;
          left: 0;
          right: 0;
          top: 50%;
          z-index: 1;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>
